import { apiService } from '../../services/apiService';
import { GetLeadsResponse } from './types';

export interface AllLeadCounts {
  booking: number;
  waitlist: number;
  website: number;
  corporate: number;
  studioContact: number;
  total: number;
  /** Booking leads created in the current calendar month (other sources not included). */
  bookingThisMonth: number;
}

export async function fetchAllLeadCounts(): Promise<AllLeadCounts> {
  const [leadsResponse, waitlistStats, websiteResponse, corporateResponse, studioContactResponse] = await Promise.all([
    apiService.getLeads({ page: 1, pageSize: 1 }) as Promise<GetLeadsResponse>,
    apiService.getWaitlistStats(),
    apiService.getWebsiteInquiries({ page: 1, pageSize: 1 }),
    apiService.getCorporateLeads({ page: 1, pageSize: 1 }),
    apiService.getStudioContactInquiries({ page: 1, pageSize: 1 }),
  ]);

  const booking = leadsResponse.total ?? (leadsResponse.leads || []).length ?? 0;
  const waitlist = waitlistStats?.total ?? 0;
  const website = websiteResponse?.total ?? (websiteResponse?.inquiries || []).length ?? 0;
  const corporate = corporateResponse?.total ?? (corporateResponse?.leads || []).length ?? 0;
  const studioContact = studioContactResponse?.total ?? (studioContactResponse?.inquiries || []).length ?? 0;
  const bookingThisMonth = leadsResponse.thisMonth ?? 0;

  return {
    booking,
    waitlist,
    website,
    corporate,
    studioContact,
    total: booking + waitlist + website + corporate + studioContact,
    bookingThisMonth,
  };
}
